import { cn } from './listingCardUtils.js';

export default function ListingCardOfferStrip({ listing, show = {}, tier = 'basic', variant = 'content' }) {
  if (!show.offer || !listing.offer) return null;

  const text = typeof listing.offer === 'string' ? listing.offer : listing.offer.text || listing.offer.title || 'Special offer available';

  return (
    <div
      className={cn(
        'rounded-md border px-3 py-2 text-sm font-medium',
        variant === 'hero'
          ? 'border-white/25 bg-white/15 text-white'
          : tier === 'spotlight'
            ? 'border-amber-200 bg-amber-50 text-amber-900'
            : 'border-sky-100 bg-sky-50 text-sky-900',
      )}
    >
      {text}
    </div>
  );
}
